module.exports = __webpack_public_path__ + "static/media/Fearures bg.59f0d689.png";